import type { CandidateVacancy } from '../types';
import { mockCandidateRegion } from './mockCandidateRegion';

type CandidateCity = NonNullable<CandidateVacancy['cities']>[number];

export function mockCandidateCity(
  overrides: Partial<CandidateCity> = {}
): CandidateCity {
  return {
    id: 1,
    name: 'Paris',
    region: mockCandidateRegion(),
    ...overrides,
  };
}
